import Lazyload from 'vue-lazyload';
export default Lazyload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.6.17@vant/es/lazyload/index.js
// module id = null
// module chunks = 